export default class ActionViewmodel {
    public id: number | undefined = undefined;
    public description: string = '';
    public type: string = '';
    public date: Date = new Date();
}